import {
  DetailsSidebar,
  DetailsSidebarProvider,
  DetailsSidebarTrigger,
  Footer,
  HStack,
} from '@eluve/components';
import { useIsAppointmentSigned } from '@eluve/frontend-appointment-hooks';

import { AppointmentLastSaved } from './AppointmentLastSaved';
import { AppointmentPDFOutputControls } from './AppointmentPDFOutputControls';
import { SignAndSyncAppointmentButton } from './SignAndSyncAppointmentButton';
import { SignedSummaryFooter } from './SignedSummaryFooter';
import { VersionHistorySidebar } from './VersionHistorySidebar';

export const AppointmentSummaryFooter: React.FC = () => {
  const isAppointmentSigned = useIsAppointmentSigned();
  return (
    <Footer>
      <HStack
        justify="between"
        gap={1}
        className="mx-auto max-w-screen-lg px-2"
      >
        <DetailsSidebarProvider overlayOnly>
          <DetailsSidebar title="Version History" size="md">
            <VersionHistorySidebar />
          </DetailsSidebar>
          <DetailsSidebarTrigger>
            <AppointmentLastSaved />
          </DetailsSidebarTrigger>
        </DetailsSidebarProvider>

        <HStack wFull={false}>
          {isAppointmentSigned ? (
            <SignedSummaryFooter />
          ) : (
            <>
              <AppointmentPDFOutputControls />
              <SignAndSyncAppointmentButton />
            </>
          )}
        </HStack>
      </HStack>
    </Footer>
  );
};
